export const CACHE_FOREVER = {
  staleTime: Infinity,
  cacheTime: Infinity,
  retry: false,
  refetchOnMount: false
};
export const productTypeParam = productType => productType ? {
  productType: {
    domainProductType: productType
  }
} : {};
//# sourceMappingURL=priceQueries.utils.js.map